import { render, staticRenderFns } from "./TreatmentIcon.vue?vue&type=template&id=1f64c59e"
import script from "./TreatmentIcon.vue?vue&type=script&lang=js"
export * from "./TreatmentIcon.vue?vue&type=script&lang=js"
import style0 from "./TreatmentIcon.vue?vue&type=style&index=0&id=1f64c59e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports